@for (message of messages(); track $index) {
  <div class="message" [attr.data-message-type]="message.type">
    <h4 class="title">{{ message.title | SKWTranslate }}</h4>
    <p class="content">{{ message.content | SKWTranslate }}</p>
  </div>
}
